import ReviewDefault from "../components/Review/Default";
import ReviewInvitations from "../components/Review/ReviewInvitations";
import PendingReviews from "../components/Review/PendingReviews";
import CompletedReviews from "../components/Review/CompletedReviews";

import ReviewManuscript from "../components/Review/ReviewManuscript";
import ManuscriptReviews from "../components/Review/ManuscriptReviews";
import ExternalReviewerInvite from "../components/Review/ExternalReviewerInvitation";

const routes = [
  {
    path: "/reviewer/invite/:invite",
    name: "externalReviewerInvite",
    component: ExternalReviewerInvite,
    props: true,
    meta: { requiresVisitor: true },
  },
  {
    path: "/reviews",
    component: ReviewDefault,
    redirect: "/reviews/invitations",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "invitations",
        name: "reviewInvitations",
        component: ReviewInvitations,
        meta: {
          requiresAuth: true,
          description: "Invitations for review",
        },
      },
      {
        path: "pending",
        name: "pendingReviews",
        component: PendingReviews,
        meta: {
          requiresAuth: true,
          description: "Manuscripts pending review",
        },
      },
      {
        props: true,
        path: "pending/:manuscriptId/:invitationId",
        name: "reviewManuscript",
        component: ReviewManuscript,
        meta: {
          requiresAuth: true,
          description: "Review manuscript",
        },
      },
      {
        path: "completed",
        name: "completedReviews",
        component: CompletedReviews,
        meta: {
          requiresAuth: true,
          description: "Completed reviews",
        },
      },
      {
        path: "completed/:manuscriptId",
        name: "manuscriptReviews",
        component: ManuscriptReviews,
        meta: {
          requiresAuth: true,
          description: "Manuscript reviews",
        },
      },
    ],
  },
];

export default routes;
